export const recountPageIndex = (currentPageIndex, newPageSize, totalItems) => {
    //Change page index if the current page wont display any items with the new page size
    while(currentPageIndex !== 0 && (currentPageIndex * newPageSize) >= totalItems){
        currentPageIndex--;
    } 

    return currentPageIndex;
};